import { ApiUtils } from '@/utils/ApiUtils'
import { resetState } from '@/utils/Storage'

const initialState = ()=> {
  return  {
    availableClientFormFields: [],
    loadingAvailableClientFormFields: false
  }
}

export default {
  namespaced: true,
  state: {
    availableClientFormFields: [],
    loadingAvailableClientFormFields: false
  },
  mutations: {
    reset: (state) => {
      const s = initialState()
      resetState(state, s);
    },
    setAvailableClientFormFields(state, fields){
      state.availableClientFormFields = fields
    },
    setLoadingAvailableClientFormFields(state, payload) {
      state.loadingAvailableClientFormFields = payload
    }
  },
  actions: {
    async loadAvailableClientFormFields(ctx) {

      if(ctx.state.loadingAvailableClientFormFields) return true

      ctx.commit('setLoadingAvailableClientFormFields', true)
      const response = await ApiUtils.makeGet(`provider/client-fields`)
      ctx.commit('setLoadingAvailableClientFormFields', false)

      if(!response.ok){
        const json = await response.json()

        return
      }

      const json = await response.json()
      ctx.commit('setAvailableClientFormFields', json.result.fields)

    }
  }
}
